import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AppCatalogMainView from '../views/AppCatalogMainView.vue'
import AndroidMobileCfgView from '../views/AndroidMobileCfgView.vue'
import AndroidAppCfgView from '../views/AndroidAppCfgView.vue'
import EMMLocationView from '../views/EMMLocationView.vue'

const routes: Array<RouteRecordRaw> = [
  {
        path: '/app/appcatalog',
        name: 'AppCatalog',
        component: AppCatalogMainView,
        meta: {
            title: 'アプリカタログ'
        }
  },
  {
        path: '/android/mobilecfg',
        name: 'AndroidMobileCfg',
        component: AndroidMobileCfgView,
        meta: {
            title: 'Androidモバイル設定'
        }
  },
  {
        path: '/android/appcfg',
        name: 'AndroidAppCfg',
        component: AndroidAppCfgView,
        meta: {
            title: 'Androidアプリ設定'
        }
  },
  {
        path: '/mobile/emmlocation',
        name: 'EMMLocationView',
        component: EMMLocationView,
        meta: {
            title: '位置情報確認'
        }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.afterEach((to, from) => {
    if (typeof to.meta.title === "string") {
        document.title = to.meta.title;
    }
})

export default router
